export default __webpack_public_path__ + "static/media/Miscellaneous08.fd2e168d.jpg";